import IconButton from "@/components/IconButton";
import { useState } from "react";
import EditMetricModal from "./EditMetricModal";
import classNames from "classnames";

interface PATMetricCardProps {
  label: string;
  value: string | number;
  onEdit?: (newValue: string) => void;
}

export default function PATMetricCard({ label, value, onEdit }: PATMetricCardProps) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const isEmpty = !value && value !== 0;

  const formatValue = (val: string | number) => {
    if (!val && val !== 0) return "--";
    if (typeof val === "number" && label.includes("Rating")) {
      return val.toFixed(2);
    }
    return val;
  };

  const handleSave = (newValue: string) => {
    if (!newValue.trim()) {
      onEdit?.("");
      return;
    }

    if (label.includes("Rating")) {
      const parsed = parseFloat(newValue);
      if (isNaN(parsed) || parsed < 0) return;
      const formatted = parsed.toFixed(2);
      onEdit?.(formatted);
    } else {
      onEdit?.(newValue);
    }
  };

  const valueClasses = classNames("text-sys-brand-on-surface", {
    "text-headline-small-bold": true,
    "opacity-20": isEmpty
  });

  return (
    <>
      <div
        className={classNames(
          "p-4 flex flex-col h-full rounded-lg transition-all duration-200 ease-in-out min-w-0 w-full",
          "border border-sys-brand-outline"
        )}
      >
        <div className="flex items-center h-8">
          <span className="text-body-medium text-sys-brand-on-surface">{label}</span>
          {onEdit && <IconButton name="edit" title="Edit" onClick={() => setIsDialogOpen(true)} className="ml-1" />}
        </div>
        <div className={classNames(valueClasses, "overflow-hidden text-ellipsis whitespace-nowrap")}>
          {formatValue(value)}
        </div>
      </div>

      {onEdit && (
        <EditMetricModal
          open={isDialogOpen}
          onClose={() => setIsDialogOpen(false)}
          fieldName={label}
          initialValue={value}
          onSave={handleSave}
        />
      )}
    </>
  );
}
